<template>
    <div class="customers-invites-delete">
        <button type="button" @click="showModal = true">
            <IconBin />
        </button>

        <portal to="modals">
            <ConfirmModal
                v-if="showModal"
                name="customers-invites-delete"
                :title="$t('crm.customers.invites.delete.title')"
                :ok-label="$t('misc.delete')"
                @confirmed="confirmed"
                @canceled="showModal = false"
            >
                <template #content>
                    <div class="customers-invites-delete__content">
                        <p v-text="$t('crm.customers.invites.delete.content')" />
                    </div>
                </template>
            </ConfirmModal>
        </portal>
    </div>
</template>

<script>
import { deleteCustomersInvite } from '../../api/customers';
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';
import { IconBin } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'CustomersInvitesDelete',
    components: {
        ConfirmModal,
        IconBin,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
        };
    },
    methods: {
        async confirmed() {
            try {
                await deleteCustomersInvite(this.id);
                this.showModal = false;
                this.$emit('confirmed');
            } catch (err) {
                console.log(err);
            }
        },
    },
};
</script>

<style lang="scss" src="./CustomersInvitesDelete.scss"></style>
